import { toAccount } from "viem/accounts";
import { keccak256, serializeTransaction, signatureToHex, hashMessage, hashTypedData } from "viem";
export function toViem(address) {
    return toAccount({
        address: address.address,
        signMessage: async (bundle) => {
            const hashToSign = hashMessage(bundle.message).slice(2);
            const res = await address.sign(hashToSign);
            const recoveryCode = res.v;
            return signatureToHex({
                r: `0x${res.r}`,
                s: `0x${res.s}`,
                v: BigInt(recoveryCode) + 27n,
            });
        },
        signTransaction: async (transaction, args) => {
            const serializer = args?.serializer ?? serializeTransaction;
            const hashToSign = keccak256(serializer(transaction));
            let res;
            try {
                res = await address.sign(hashToSign.slice(2));
            }
            catch (exc) {
                throw new Error(`MPC Engine failed to sign.`, { cause: exc });
            }
            const recoveryCode = res.v;
            const sig = {
                r: res.r,
                s: res.s,
                v: BigInt(recoveryCode) + 27n,
            };
            return serializer(transaction, sig);
        },
        signTypedData: async (typedData) => {
            const hashToSign = hashTypedData(typedData);
            let res;
            try {
                res = await address.sign(hashToSign.slice(2));
            }
            catch (exc) {
                throw new Error(`MPC Engine failed to sign.`, { cause: exc });
            }
            const recoveryCode = res.v;
            return signatureToHex({
                r: `0x${res.r}`,
                s: `0x${res.s}`,
                v: BigInt(recoveryCode) + 27n,
            });
        }
    });
}
